import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from "react-redux";
import './Toast.css';

import IconToast from './svg/IconToast';
import IconSuccess from './svg/IconSuccess';
import IconWarning from './svg/IconWarning';
import IconClose from '../svg/IconClose';

import { removeToast } from "../../../actions/index";

function Toast({ id, content, duration, style, typeClass = 'info', iconStyle }) {
  const dispatch = useDispatch();
  const types = [
    { type: 'info', icon: <IconToast /> },
    { type: 'success', icon: <IconSuccess /> },
    { type: 'neutral', icon: <IconSuccess /> },
    { type: 'remove', icon: <IconSuccess color={'white'} /> },
    { type: 'warning', icon: <IconWarning color={'#141414'} /> },
  ]
  const type = types.find( x => x.type === typeClass );

  useEffect(() => {
    setTimeout(() => {  dispatch(removeToast(id)); }, duration);    
  }, [id, duration, dispatch])
  const onClose = () => { dispatch(removeToast(id)); }
  
  return (
    <div className={`flexRow toast`} style={{ ...style}}>
      <div className={`toast-icon-section ${typeClass}`} style={iconStyle}>
        {type && type.icon}
      </div>
      <div className={`toast-content`}>
        { content && React.cloneElement(content, {}) }
      </div>
      <IconClose size={16} color={'#DFDFDF'} onClick={onClose} style={{cursor: 'pointer', position: 'relative', right: 0, marginRight: 12, marginLeft: 12}} />
    </div>
  )
}

Toast.propTypes = {
  id: PropTypes.any.isRequired,
  content: PropTypes.element,
  duration: PropTypes.number,
  className: PropTypes.string,
  typeClass: PropTypes.string,
  style: PropTypes.object,
  onClose: PropTypes.func
}

export default Toast;
